import { EditableEntity, IEditableEntity, IReadablePropEventBroker } from '@zdrbm/zdr-native-tools';
import { SuggestionDTO } from '../services/AssistantDTOs';

export interface ISuggestion extends IEditableEntity {
    agentId: IReadablePropEventBroker<string>;
    query: IReadablePropEventBroker<string>;
}

export class Suggestion extends EditableEntity<keyof ISuggestion> implements ISuggestion {
    agentId: IReadablePropEventBroker<string>;
    query: IReadablePropEventBroker<string>;

    constructor(suggestion: SuggestionDTO) {
        super(undefined);

        this.agentId = this.createPropEventBroker<string>('agentId', suggestion.agent_id);
        this.query = this.createPropEventBroker<string>('query', suggestion.query);
    }

    getEntityName(): string {
        return 'Suggestion';
    }
}
